import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { AuthService } from 'src/services/auth.service';
import { EcitationUserService } from 'src/services/ecitation-user.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent {
  @ViewChild('head')
  head!: ElementRef;
  title = 'eCitation';
  user: any;
  isSecured: boolean = false;
  constructor(public router: Router, public cdr: ChangeDetectorRef, private authService: AuthService,
    private ecitationUserService: EcitationUserService) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        let currentUrl = event.urlAfterRedirects.split('/')[1]
        if (currentUrl.includes('secure')) {
          this.isSecured = true;
        }
        if (event.id === 1 && event.url == event.urlAfterRedirects) {
          this.setRoles(event.url.split('/')[2])
        }
        document.getElementById('activeEle')?.focus();
      }
      if (event instanceof NavigationStart) {
        let currentUrl = event.url.split('/')[2]

        console.log(event.navigationTrigger)
        if (event.navigationTrigger == 'popstate') { 
          this.setRoles(currentUrl)
        }
      document.getElementById('activeEle')?.focus();
      }
     
    })

  }

  setRoles(currentUrl: string) {
    let adminUrls = ['ecitationMuniStatus', 'publicCitationSearch', 'ecitationCourt', 'ecitationVendor', 'ecitationUsers'];

    if (adminUrls.includes(currentUrl)) {
      this.authService.isNonAdminActive = false;
      sessionStorage.setItem('isNonAdminActive', 'false')

      this.ecitationUserService.reloadComponent1()
    } else {

      this.authService.isNonAdminActive = true;
      sessionStorage.setItem('isNonAdminActive', 'true')
      this.ecitationUserService.reloadComponent1()
    }
  }
  getLocalStorage() {
    let loginData = sessionStorage.getItem('loggedInUser');
    let item = loginData && JSON.parse(loginData)
    this.user = item?.username
    return loginData
  }

}
